import React from "react";
import { Popconfirm } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

export const ConfirmButton = ({ handleOnConfirm, okText, cancelText, title }) => (
  <Popconfirm title={useTranslation({ id: title })} placement="leftBottom" onConfirm={handleOnConfirm} onCancel={() => false} okText={okText} cancelText={cancelText}>
    <S.RegisterButton type="primary" id="drawer-outbound" htmlType="submit">
      {useTranslation({ id: "save" })}
    </S.RegisterButton>
  </Popconfirm>
);

const isConfirmModalOpen = (formViewOrEditModified) => formViewOrEditModified === true;

export const ConfirmCancelButton = ({ handleOnConfirm, okText, cancelText, formViewOrEditModified, handleClose, messageDescription }) => {
  const CANCEL = useTranslation({ id: "cancel" });

  return isConfirmModalOpen(formViewOrEditModified) ? (
    <Popconfirm title={messageDescription} placement="rightBottom" onConfirm={handleOnConfirm} onCancel={() => false} okText={okText} cancelText={cancelText}>
      <S.CancelButton htmlType="submit">{CANCEL}</S.CancelButton>
    </Popconfirm>
  ) : (
    <S.CancelButton htmlType="submit" onClick={handleClose}>
      {CANCEL}
    </S.CancelButton>
  );
};
